export default {
  AJAX_SUCCESS: 10000,
  EVENT_TOKE: 'Authorization',
  COOKIE_PERFIX_TOKEN: 'Bearer ',
  EVENT_USER_INFO: 'userInfo',
  EVENT_MEMBER_LEVEL: 'eventMemberLevel',
  EVENT_USER_PHONE: 'userPhone',
  EVENT_USER_ORGID: 'userOrgID',
  EVENT_USER_LOGO: 'orgLogo',
  EVENT_USER_UID: 'userUid',
};
